(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-footer-currency')) {
    customElements.define('mh-footer-currency', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const form = this.querySelector('form');
        const select = this.querySelector('select[name="country_code"]');
        if (!form || !select) return;
        select.addEventListener('change', () => form.requestSubmit(), { signal: this.controller.signal });
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mh-infinite-catalog')) {
 customElements.define('mh-infinite-catalog', class extends HTMLElement {
  connectedCallback() {
   if (this.hasAttribute('data-feed-response') || this.initialized) return;
   this.initialized = true;
   this.grid = this.querySelector('.resource-list--grid');
   this.more = this.querySelector('.mh-catalog-load-more');
   this.status = this.querySelector('.mh-catalog-status');
   this.sentinel = this.querySelector('.mh-catalog-sentinel');
   if (!this.grid || !this.more || !this.sentinel) return;
   this.controller = new AbortController();
   this.pages = new Set();
   this.nextUrl = this.dataset.feedUrl;
   this.ready = false;
   this.more.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.loadPage(this.nextUrl, !this.ready);
   }, { signal: this.controller.signal });
   if ('IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => {
     if (entries.some(entry => entry.isIntersecting) && this.ready && !this.failed) {
      this.loadPage(this.nextUrl);
     }
    }, { rootMargin: '500px 0px' });
   }
   this.setAttribute('data-initializing', '');
   this.loadPage(this.nextUrl, true);
  }

  disconnectedCallback() {
   this.observer?.disconnect();
   this.controller?.abort();
   this.initialized = false;
  }

  async loadPage(rawUrl, replace = false) {
   if (!rawUrl || this.loading || this.pages.has(rawUrl)) return;
   const url = new URL(rawUrl, window.location.origin);
   if (url.origin !== window.location.origin) return;
   this.loading = true;
   this.failed = false;
   this.observer?.unobserve(this.sentinel);
   this.setAttribute('aria-busy', 'true');
   this.more.setAttribute('aria-disabled', 'true');
   this.status.textContent = this.dataset.loading;
   try {
    const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Catalog response failed');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const incoming = document.querySelector('mh-infinite-catalog[data-feed-response]');
    if (!incoming) throw new Error('Catalog grid missing');
    const cards = [...incoming.querySelectorAll('.resource-list--grid > .resource-list__item')];
    if (!cards.length) throw new Error('Catalog page empty');
    const existing = new Set(replace ? [] : [...this.grid.children].map(card => card.dataset.productId));
    const unique = cards.filter(card => {
     const id = card.dataset.productId;
     if (!id || existing.has(id)) return false;
     existing.add(id);
     return true;
    });
    if (!unique.length) throw new Error('Catalog page repeated');
    if (replace) this.grid.replaceChildren(...unique);
    else this.grid.append(...unique);
    this.pages.add(rawUrl);
    this.ready = true;
    this.dataset.page = incoming.dataset.page;
    this.dataset.total = incoming.dataset.total;
    const next = incoming.querySelector('.mh-catalog-load-more');
    this.nextUrl = next?.dataset.nextUrl || '';
    if (this.nextUrl) {
     this.more.href = next.href;
     this.more.hidden = false;
     this.status.textContent = this.dataset.loaded
      .replace('[count]', String(this.grid.children.length))
      .replace('[total]', incoming.dataset.total);
    } else {
     this.more.hidden = true;
     this.status.textContent = this.dataset.finished;
    }
   } catch (error) {
    if (error.name === 'AbortError') return;
    this.failed = true;
    this.status.textContent = this.dataset.error;
    this.more.hidden = false;
   } finally {
    this.loading = false;
    this.removeAttribute('data-initializing');
    this.removeAttribute('aria-busy');
    this.more.removeAttribute('aria-disabled');
    if (this.nextUrl && !this.failed && this.isConnected) this.observer?.observe(this.sentinel);
   }
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-email-offer"]) return;
  try {
    
  if (!customElements.get('mh-email-offer')) {
    customElements.define('mh-email-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('.mh-offer__tab');
        this.form = this.querySelector('form');
        this.success = this.querySelector('[data-offer-success]');
        this.storageKey = 'mh-email-offer-v2';
        this.events = new AbortController();
        const signal = this.events.signal;
        this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.closeOffer(), { signal }));
        this.querySelector('[data-offer-open]').addEventListener('click', () => this.openOffer(), { signal });
        this.querySelector('[data-offer-hide-tab]').addEventListener('click', () => {
          this.tab.hidden = true;
          this.saveSession('tab-hidden', true);
        }, { signal });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeOffer(); }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeOffer();
        }, { signal });
        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('mh-offer-is-open'), { signal });
        if (this.success) {
          this.querySelector('[data-offer-heading]').hidden = true;
          this.dialog.setAttribute('aria-labelledby', 'MhOfferSuccessTitle');
          this.dialog.removeAttribute('aria-describedby');
          this.save('subscribed', true);
          this.copyButton = this.querySelector('[data-offer-copy]');
          this.copyButton.addEventListener('click', async () => {
            const code = this.querySelector('[data-offer-code]').textContent.trim();
            try {
              await navigator.clipboard.writeText(code);
              this.copyButton.textContent = this.copyButton.dataset.copied;
            } catch {
              const selection = window.getSelection();
              const range = document.createRange();
              range.selectNodeContents(this.querySelector('[data-offer-code]'));
              selection.removeAllRanges();
              selection.addRange(range);
            }
          }, { signal });
          this.openOffer();
          return;
        }
        if (this.querySelector('[data-offer-errors]')) { this.openOffer(); return; }
        if (this.dataset.designMode === 'true') return;
        if (this.read('subscribed')) return;
        if (this.readSession('dismissed')) {
          this.tab.hidden = Boolean(this.readSession('tab-hidden'));
          return;
        }
        const started = Number(this.readSession('started') || Date.now());
        this.saveSession('started', started);
        const delay = Math.max(0, Number(this.dataset.delay) * 1000 - (Date.now() - started));
        this.timer = setTimeout(() => this.autoOpen(), delay);
      }
      autoOpen() {
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select')) {
          this.timer = setTimeout(() => this.autoOpen(), 2000);
          return;
        }
        this.openOffer();
      }
      openOffer() {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.tab.hidden = true;
        this.saveSession('tab-hidden', false);
        this.dialog.showModal();
        document.documentElement.classList.add('mh-offer-is-open');
        const focus = this.querySelector('.mh-offer__success-title') || this.querySelector('#MhOfferTitle');
        focus?.focus({ preventScroll: true });
      }
      closeOffer() {
        this.dialog.close();
        this.saveSession('dismissed', true);
        this.tab.hidden = Boolean(this.success || this.read('subscribed'));
        if (!this.tab.hidden) this.querySelector('[data-offer-open]').focus({ preventScroll: true });
        else if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      read(key) { try { return JSON.parse(localStorage.getItem(`${this.storageKey}:${key}`)); } catch { return null; } }
      save(key, value) { try { localStorage.setItem(`${this.storageKey}:${key}`, JSON.stringify(value)); } catch {} }
      readSession(key) { try { return JSON.parse(sessionStorage.getItem(`${this.storageKey}:${key}`)); } catch { return null; } }
      saveSession(key, value) { try { sessionStorage.setItem(`${this.storageKey}:${key}`, JSON.stringify(value)); } catch {} }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.events?.abort();
        document.documentElement.classList.remove('mh-offer-is-open');
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-product-photos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-product-photos')) {
    customElements.define('mh-product-photos', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mh-product-photos__track');
        this.controls = this.querySelector('.mh-product-photos__controls');
        this.buttons = [...this.querySelectorAll('[data-step]')];
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = max < 2;
          this.buttons[0].disabled = this.track.scrollLeft < 2;
          this.buttons[1].disabled = this.track.scrollLeft >= max - 2;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.track.firstElementChild;
          if (!card) return;
          const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
          this.track.scrollBy({ left: distance * Number(button.dataset.step), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options));
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.mh-product-photos__card');
          if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-product-shipping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-product-shipping')) {
    customElements.define('mh-product-shipping', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
